export const CheckoutSteps = {
	Addresses: "addresses",
	Delivery: "delivery",
	Payment: "payment",
	Review: "review",
} as const;

export type CheckoutSteps = (typeof CheckoutSteps)[keyof typeof CheckoutSteps];
